export default "__VITE_ASSET__BQ$l9h4d__"